__turbopack_context__.v({
  "policy-sidebar": "policy-sidebar-module-scss-module__rXFl2q__policy-sidebar",
  "policy-sidebar--title": "policy-sidebar-module-scss-module__rXFl2q__policy-sidebar--title",
});
